import React from 'react';
import WidgetMachinesSection from 'components/quote_builder_widget/sections/WidgetMachinesSection';

const PRINTING_MACHINE_LABELS = {
  information: 'printing_machines_information',
  add: 'add_printing_machine',
  select: 'select_printing_machine',
  noneAdded: 'no_printing_machines_enabled',
  noWidgetMaterials: 'no_widget_materials_for_printing',
  noMachines: 'no_printing_machines',
  noMachinesForMaterials: 'no_printing_machines_for_materials',
  notUsed: 'printing_machine_not_used',
  failedToLoad: 'failed_to_load_printing_machines',
  failedToUpdate: 'failed_to_update_printing_machine',
};

const PrintingMachinesSection = ({ onPrintingMachinesChange }) => (
  <WidgetMachinesSection
    machineKey="printing_machine"
    listUrl="/quote-builder/widgets/printing-machines"
    listField="printing_machines"
    labels={PRINTING_MACHINE_LABELS}
    machineLabel="quote_builder.printing_machine"
    onMachinesChange={onPrintingMachinesChange}
  />
);

export default PrintingMachinesSection;
